export function resolveCartItemLanguage(cartItem, productsByType, language) {
  if (!cartItem?.crossLanguageId) return cartItem;

  const allProducts = [
	...(productsByType.main || []),
	...(productsByType.addon || [])
  ];

  const match = allProducts.find(
	p =>
	  p?.product?.metadata?.cross_language_id === cartItem.crossLanguageId &&
	  p?.product?.metadata?.language?.toLowerCase() === language
  );

  if (!match) return cartItem;

  const price =
	match.prices.find(
	  p => p.recurring?.interval === cartItem.price?.recurring?.interval
	) || match.prices[0];

  return {
    ...cartItem,
    id: match.product.id,
    name: match.product.name,
    price
  };
}